import { PropsWithChildren, useContext, useEffect } from 'react';
import { AppContext } from 'providers/AppProvider';
import { baseAction } from 'store/actions';
import { Container, LoadingScreen, TopBar } from 'components';
import { getMode } from 'helpers';

export function Template(props: Readonly<PropsWithChildren>) {
	const { dispatch, t, flowType, state } = useContext(AppContext);
	const { language } = state.language;
	const documentTitle = t(`${flowType}-page-title`);
	const title = t(`page_title_${flowType}`);

	useEffect(() => dispatch([baseAction, { title }]), [title, dispatch]);

	useEffect(() => {
		document.documentElement.setAttribute('lang', language.toLowerCase());
		document.title = documentTitle;
	}, [documentTitle, language]);

	return (
		<div className={`theme--${getMode(flowType)}`}>
			<TopBar />
			<Container className="page-container">{props.children}</Container>
			<LoadingScreen />
		</div>
	);
}
